import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import UserManagement from "../views/UserManagement.vue";
import PdfGenerator from "../views/PdfGenerator.vue";
import PdfList from "../views/PdfList.vue";

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/users",
    name: "UserManagement",
    component: UserManagement,
    meta: { requiresAuth: true, requiresAdmin: true },
  },
  {
    path: "/generate",
    name: "PdfGenerator",
    component: PdfGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: "/generate1",
    name: "PdfGenerator1",
    component: PdfGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: "/generate2",
    name: "PdfGenerator2",
    component: PdfGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: "/generate3",
    name: "PdfGenerator3",
    component: PdfGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: "/generate4",
    name: "PdfGenerator4",
    component: PdfGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: "/generate5",
    name: "PdfGenerator5",
    component: PdfGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: "/generate6",
    name: "PdfGenerator6",
    component: PdfGenerator,
    meta: { requiresAuth: true },
  },
  {
    path: "/pdfs",
    name: "PdfList",
    component: PdfList,
    meta: { requiresAuth: true },
  },
 
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  if (to.meta.requiresAuth && !token) {
    next("/login");
  } else if (to.meta.requiresAdmin && !isAdmin) {
    next("/dashboard");
  } else if (to.path === "/login" && token) {
    next("/dashboard");
  } else {
    next();
  }
});

export default router;
